import React, { useState, useEffect } from 'react';
import { Popper, Paper, ClickAwayListener, ListItemButton, ListItemText, ListItemIcon, Switch } from '@mui/material';

import { useAuth } from '@contexts/AuthContext';

import './styles.scss';

import { DarkModeRounded, LogoutRounded, VerifiedRounded } from "@mui/icons-material";

export default function UserCard({ open, anchorEl, onClose, onOpenProfileConfig }) {
    const { user } = useAuth();

    const handleOpenProfile = () => {
        onOpenProfileConfig();
        onClose();
    };



    const [darkMode, setDarkMode] = useState(window.appearenceMode === 'dark')

    useEffect(() => {
        function handleAppearenceChange(event) {
            const appearenceMode = event.detail;
            setDarkMode(appearenceMode === 'dark');
        }

        window.addEventListener("appearence-change", handleAppearenceChange);

        return () => {
            window.removeEventListener("appearence-change", handleAppearenceChange);
        };
    }, []);

    function handleChangeTheme() {
        window.triggerAppearence();
    }

    return (
        <Popper
            open={open}
            anchorEl={anchorEl}
            placement="right-start"
            modifiers={[
                {
                    name: 'offset',
                    options: {
                        offset: [8, 0],
                    },
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'viewport',
                        padding: 8,
                    },
                },
            ]}
            style={{ zIndex: 9999 }}
        >
            <ClickAwayListener onClickAway={onClose}>
                <Paper
                    elevation={8}
                    className="user-card"
                    sx={{
                        backgroundColor: 'var(--surface-10)',
                        borderRadius: '12px',
                        border: '1px solid var(--surface-9)',
                        overflow: 'hidden',
                        minWidth: 280,
                        maxWidth: 320,
                    }}
                >
                    <div className="user-card-content">
                        <div className="user-card-header">
                            <div className="user-card-avatar">
                                <img src={user?.avatar} alt="User Avatar" />
                                {
                                    user?.verified ? (
                                        <div className="user-card-verified">
                                            <VerifiedRounded />
                                        </div>
                                    ) : null
                                }
                            </div>
                            <div className="user-card-info">
                                <h5 className="bold">{user?.username}</h5>
                                {user?.nickname ? (
                                    <small className="user-card-nickname">@{user?.nickname}</small>
                                ) : null}
                            </div>
                        </div>

                        <button
                            className="user-card-action-btn my-1"
                            onClick={handleOpenProfile}
                        >
                            Configurar Perfil
                        </button>

                        <hr />

                        <div className="user-card-actions">

                            <div className="card-option-row">
                                <DarkModeRounded />
                                <h5 className='card-option-title'>Modo escuro</h5>
                                <Switch checked={darkMode} onChange={handleChangeTheme} size="small" />
                            </div>

                            <hr />

                            <div className="card-option-row action" onClick={window.logout}>
                                <LogoutRounded />
                                <h5 className='card-option-title'>Sair</h5>
                            </div>
                        </div>
                    </div>
                </Paper>
            </ClickAwayListener>
        </Popper>
    );
}
